export default __webpack_public_path__ + "static/media/pacifa.0d6928bf.png";